const pageName = { singular: 'Produk', plural: 'Produk' }

export default [
  {
    path: '/produk',
    name: 'data-produk',
    component: () => import('@/views/pages/komship/produk/DataProduk.vue'),
    meta: {
      name: pageName,
      routeCreate: 'add-produk',
      routeEdit: 'edit-produk',
      routeBundling: 'create-bundling',
      routeEditBundling: 'edit-bundling',
      resource: 'Produk',
      action: 'manage',
      breadcrumb: [
        {
          text: pageName.plural,
          active: true,
        },
      ],
    },
  },
  {
    path: '/add-produk',
    name: 'add-produk',
    component: () => import('@/views/pages/komship/produk/AddProduk.vue'),
    meta: {
      name: pageName,
      resource: 'Produk',
      routeAllProduk: 'data-produk',
      routeDraftProduk: 'data-produk',
      action: 'manage',
      breadcrumb: [
        {
          text: pageName.plural,
          active: true,
        },
      ],
    },
  },
  {
    path: '/edit-produk/:product_id',
    name: 'edit-produk',
    component: () => import('@/views/pages/komship/produk/EditProduk.vue'),
    meta: {
      name: pageName,
      resource: 'Produk',
      navActiveLink: 'data-produk',
      routeAllProduk: 'data-produk',
      routeDraftProduk: 'data-produk',
      action: 'manage',
      breadcrumb: [
        {
          text: pageName.plural,
          active: true,
        },
      ],
    },
  },
  {
    path: '/create-bundling/:product_id',
    name: 'create-bundling',
    component: () => import('@/views/pages/komship/produk/CreateBundling.vue'),
    meta: {
      name: pageName,
      resource: 'Produk',
      navActiveLink: 'data-produk',
      routeAllProduk: 'data-produk',
      routeDraftProduk: 'data-produk',
      action: 'manage',
      breadcrumb: [
        {
          text: pageName.plural,
          active: true,
        },
      ],
    },
  },
  {
    path: '/edit-bundling/:product_id',
    name: 'edit-bundling',
    component: () => import('@/views/pages/komship/produk/EditBundling.vue'),
    meta: {
      name: pageName,
      resource: 'Produk',
      navActiveLink: 'data-produk',
      routeAllProduk: 'data-produk',
      routeDraftProduk: 'data-produk',
      action: 'manage',
      breadcrumb: [
        {
          text: pageName.plural,
          active: true,
        },
      ],
    },
  },
  {
    path: '/add-produk-onboarding',
    name: 'add-produk-onboarding',
    component: () => import('@/views/pages/komship/onboarding/AddProdukOnboarding.vue'),
    meta: {
      name: pageName,
      resource: 'Produk',
      routeAllProduk: 'data-produk',
      routeDraftProduk: 'data-produk',
      action: 'manage',
      breadcrumb: [
        {
          text: pageName.plural,
          active: true,
        },
      ],
    },
  },
  {
    path: '/produk/bundling-variant',
    name: 'bundling-variant',
    component: () => import('@/views/pages/komship/produk/bundling-variant/Page.vue'),
    meta: {
      name: 'Produk Bundling Variant',
      resource: 'Produk',
      navActiveLink: 'data-produk',
      routeAllProduk: 'data-produk',
      routeDraftProduk: 'data-produk',
      action: 'manage',
      breadcrumb: [
        {
          text: pageName.plural,
          active: true,
        },
      ],
    },
  },
  {
    path: '/produk/bundling-variant/:product_id/edit',
    name: 'bundling-variant-edit',
    component: () => import('@/views/pages/komship/produk/bundling-variant/edit/Page.vue'),
    meta: {
      name: 'Edit Produk Bundling Variant',
      resource: 'Produk',
      navActiveLink: 'data-produk',
      routeAllProduk: 'data-produk',
      routeDraftProduk: 'data-produk',
      action: 'manage',
      breadcrumb: [
        {
          text: pageName.plural,
          active: true,
        },
      ],
    },
  },
]
